import { Box, Stack } from "@mui/material";
import { Icon } from "@src/appV2/redesign/components/Icon";
import { Text } from "@src/appV2/redesign/components/Text";

import { KeyboardHints } from "./KeyboardHints";

interface OmnisearchEmptyStateProps {
  variant: "initial" | "noResults";
  query?: string;
}

export function OmnisearchEmptyState(props: OmnisearchEmptyStateProps) {
  const { variant, query } = props;

  const title = variant === "initial" ? "Search anything" : `No results for "${query ?? ""}"`;
  const description =
    variant === "initial"
      ? "Find professionals by name, email, or ID · workplaces by name · or paste a shift ID to jump straight to it."
      : "Try a different name, email, or ID.";

  return (
    <Stack
      sx={(theme) => ({
        paddingY: 7,
        paddingX: 4,
        gap: 5,
        borderTop: `1px solid ${theme.palette.divider}`,
        alignItems: "center",
      })}
    >
      <Stack sx={{ alignItems: "center", gap: 3 }}>
        <Box
          sx={(theme) => ({
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 56,
            height: 56,
            borderRadius: "50%",
            backgroundColor: theme.palette.action.hover,
            color: theme.palette.text.secondary,
          })}
        >
          <Icon size="large" type="magnifying-glass" />
        </Box>
        <Stack sx={{ alignItems: "center", gap: 1 }}>
          <Text semibold sx={{ textAlign: "center" }} variant="h6">
            {title}
          </Text>
          <Text color="text.secondary" sx={{ textAlign: "center", maxWidth: 420 }} variant="body2">
            {description}
          </Text>
        </Stack>
      </Stack>
      {variant === "initial" && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            rowGap: 2,
            columnGap: 4,
          }}
        >
          <KeyboardHints />
        </Box>
      )}
    </Stack>
  );
}
